import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import AddIcon from "../../../assets/images/AddIcon.svg";

interface MediaCardsProps {
  title?: string;
  children: React.ReactNode;
  dropdownOptions?: { id: number; type: string }[];
  selectedValue?: string;
  onDropdownChange?: (value: string) => void;
  addButton?: boolean;
  onButtonClick?: () => void;
}
const MediaCardSection: React.FC<MediaCardsProps> = ({
  title,
  children,
  dropdownOptions,
  selectedValue,
  addButton,
  onButtonClick,
  onDropdownChange,
}) => {
  return (
    <Card
      elevation={0}
      square
      sx={{
        borderRadius: 0,
        boxShadow: "none",
        overflow: "hidden",
        background: "#5D5D5D",
        maxHeight: "340px",
        minHeight: "340px",
      }}
    >
      {title && (
        <Box
          sx={{
            backgroundColor: "#212121",
            padding: 1.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography fontWeight="bold" color="#FFFFFF" className="f-16">
            {title}
          </Typography>
          <Box
            sx={{
              display: "flex",
            }}
          >
            {dropdownOptions && onDropdownChange && (
              <Select
                value={selectedValue || ""}
                onChange={(e) => onDropdownChange(e.target.value)}
                variant="standard"
                sx={{
                  color: "white",
                  fontSize: "12px",
                  // minWidth: "180px",
                  width: {
                    xs: "100px",
                    sm: "90px",
                    md: "150px",
                    lg: "100px",
                  },
                  paddingBottom: "2px",
                  "& .MuiSelect-select": { paddingY: 0 },
                  "& .MuiSelect-icon": { color: "#ffffff" },
                  "&:before": { borderBottom: "1px solid #808080 !important" },
                  "&:after": { borderBottom: "1px solid #808080 !important" },
                  "&:hover:not(.Mui-disabled):before": {
                    borderBottom: "1px solid #808080 !important",
                  },
                }}
                displayEmpty
              >
                {dropdownOptions.map((option, index) => (
                  <MenuItem key={index} value={option.type}>
                    {option.type}
                  </MenuItem>
                ))}
              </Select>
            )}
            {addButton && onButtonClick && (
              <Button
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "0px",
                  width: "fit-content",
                  minWidth: "fit-content",
                  ml: 2,
                }}
              >
                <img
                  src={AddIcon}
                  alt="Add"
                  width={20}
                  height={20}
                  onClick={onButtonClick}
                />
              </Button>
            )}
          </Box>
        </Box>
      )}

      <CardContent
        className="scrollbar"
        sx={{
          padding: 1,
          "&:last-child": { paddingBottom: 1 },
          overflowY: "auto",
          maxHeight: "280px",
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};

export default MediaCardSection;
